console.log("file is loaded");

window.mwApoInit = window.mwApoInit || {};
window.mwApoInit._handlers = window.mwApoInit._handlers || [];

const originalOnEvent = window.mwApoInit.onEvent;

window.mwApoInit.onEvent = function (event, args) {
  if (typeof originalOnEvent === "function") {
    originalOnEvent.call(this, event, args);
  }

  window.mwApoInit._handlers.forEach(function (fn) {
    try {
      fn(event, args);
    } catch (error) {
      console.error("Checkbox handler error:", error);
    }
  });
};

window.mwApoInit._handlers.push(function (event, args) {
  console.log("APO event:", event);

  if (event === "init::finish") {
    initCheckboxPopovers();
  }
});

function createCheckboxPopover() {
  let popover = document.getElementById("CheckboxDescriptionPopover");

  if (popover) {
    return popover;
  }

  popover = document.createElement("div");
  popover.id = "CheckboxDescriptionPopover";
  popover.className = "checkbox-popover relative";

  popover.innerHTML = `
    <div class="checkbox-popover__content">
      <button
        type="button"
        aria-label="Close"
        class="btn btn--plain checkbox-popover__close"
        id="checkboxPopoverClose"
      >
        X
      </button>

      <div
        class="text-base checkbox-popover__text"
        id="checkboxPopoverContent"
      ></div>
    </div>
  `;

  document.body.appendChild(popover);

  return popover;
}

function showCheckboxDescription(description, checkbox) {
  const popover = createCheckboxPopover();

  const content = popover.querySelector("#checkboxPopoverContent");

  if (!content) {
    return;
  }

  content.innerHTML = description;

  const rect = checkbox.getBoundingClientRect();

  popover.style.position = "absolute";
  popover.style.top = `${rect.bottom + 10 + window.scrollY}px`;
  popover.style.left = `${rect.left + 10 + window.scrollX}px`;

  popover.setAttribute("data-open", "true");

  const closeBtn = popover.querySelector("#checkboxPopoverClose");

  if (closeBtn) {
    closeBtn.onclick = function () {
      popover.setAttribute("data-open", "false");
    };
  }
}

function hideCheckboxDescription() {
  const popover = document.getElementById(
    "CheckboxDescriptionPopover"
  );

  if (popover) {
    popover.setAttribute("data-open", "false");
  }
}

function getCheckboxDescription(id) {
  let description = null;

  if (
    typeof window.mwApoInit.response === "undefined" ||
    !window.mwApoInit.response
  ) {
    return null;
  }

  for (const val of Object.values(window.mwApoInit.response)) {
    if (!val || !val.values) {
      continue;
    }

    for (const key in val.values) {
      if (
        key === id &&
        val.values[id] &&
        val.values[id].value &&
        val.values[id].value.description
      ) {
        description = val.values[id].value.description;
        break;
      }
    }

    if (description) {
      break;
    }
  }

  return description;
}

function initCheckboxPopovers() {
  if (window.checkboxPopoverInitialized) {
    return;
  }

  window.checkboxPopoverInitialized = true;

  console.log("Checkbox popover initialized");

  document.addEventListener("change", function (e) {
    const checkbox = e.target.closest(
      '.mw-option--type-checkbox input[type="checkbox"]'
    );

    if (!checkbox) {
      return;
    }

    const id = checkbox.value;

    console.log(
      "Checkbox changed:",
      id,
      "checked:",
      checkbox.checked
    );

    const description = getCheckboxDescription(id);

    if (!description) {
      console.log("No description found for:", id);
      return;
    }

    if (checkbox.checked) {
      showCheckboxDescription(description, checkbox);
    } else {
      hideCheckboxDescription();
    }
  });

  document.addEventListener("click", function (e) {
    const checkbox = e.target.closest(
      '.mw-option--type-checkbox input[type="checkbox"]'
    );

    if (!checkbox) {
      return;
    }

    console.log(
      "Checkbox clicked:",
      checkbox.value,
      "before:",
      checkbox.checked
    );

    setTimeout(function () {
      console.log(
        "Checkbox state after click:",
        checkbox.value,
        checkbox.checked
      );
    }, 100);
  });

  document.addEventListener("click", function (e) {
    const popover = document.getElementById(
      "CheckboxDescriptionPopover"
    );

    if (!popover || popover.getAttribute("data-open") !== "true") {
      return;
    }

    const clickedInsidePopover = e.target.closest(
      "#CheckboxDescriptionPopover"
    );

    const clickedCheckbox = e.target.closest(
      '.mw-option--type-checkbox input[type="checkbox"]'
    );

    if (!clickedInsidePopover && !clickedCheckbox) {
      hideCheckboxDescription();
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () {
    initCheckboxPopovers();
  });
} else {
  initCheckboxPopovers();
}